import React, { useState } from "react";
import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";

const VALUES = [
  { id: "honesty", label: "Honesty", description: "Being truthful and transparent" },
  { id: "accountability", label: "Accountability", description: "Taking responsibility for actions" },
  { id: "spirituality", label: "Spirituality", description: "Connection to something greater" },
  { id: "family", label: "Family", description: "Importance of family relationships" },
  { id: "service", label: "Service", description: "Helping others and community" },
];

const CoreValuesStep = ({ onNext }) => {
  const [values, setValues] = useState({
    honesty: 3,
    accountability: 3,
    spirituality: 3,
    family: 3,
    service: 3,
  });
  const [submitting, setSubmitting] = useState(false);

  const handleValueChange = (valueId, rating) => {
    setValues(prev => ({ ...prev, [valueId]: rating }));
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const response = await api.submitCoreValues(values);
      onNext(response.data);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl p-6">
      <h2 className="text-xl font-bold text-gray-900 mb-2">Your Core Values</h2>
      <p className="text-gray-600 mb-6">Rate how important each value is to you (1-5)</p>

      <div className="space-y-6 mb-6">
        {VALUES.map(value => (
          <div key={value.id}>
            <div className="flex justify-between items-center mb-2">
              <div>
                <p className="font-medium text-gray-900">{value.label}</p>
                <p className="text-gray-500 text-sm">{value.description}</p>
              </div>
              <span className="text-[#1C3A7A] font-bold text-lg">{values[value.id]}</span>
            </div>
            <div className="flex gap-2">
              {[1, 2, 3, 4, 5].map(rating => (
                <button
                  key={rating}
                  onClick={() => handleValueChange(value.id, rating)}
                  className={`flex-1 h-10 rounded-lg font-medium transition-all ${
                    values[value.id] === rating
                      ? 'bg-[#1C3A7A] text-white'
                      : values[value.id] > rating
                        ? 'bg-[#1C3A7A]/20 text-[#1C3A7A]'
                        : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                  }`}
                >
                  {rating}
                </button>
              ))}
            </div>
            <div className="flex justify-between text-xs text-gray-400 mt-1">
              <span>Less important</span>
              <span>Very important</span>
            </div>
          </div>
        ))}
      </div>

      <Button
        onClick={handleSubmit}
        disabled={submitting}
        className="w-full h-12 bg-[#1C3A7A] hover:bg-[#15305f] text-white font-semibold rounded-xl"
      >
        {submitting ? (
          <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
        ) : (
          <>
            Continue
            <ChevronRight className="w-5 h-5 ml-2" />
          </>
        )}
      </Button>
    </div>
  );
};

export default CoreValuesStep;
